import { getAuth0 } from './get-auth0';
import { getUserProfile } from './getUserProfile';

type UpdateUserState = (userProfile: UserProfile) => void;

export const authenticateUser = async (updateUserState: UpdateUserState) => {
  const auth0 = getAuth0();
  if (!auth0) return;

  const token = await auth0.getTokenIfAuthenticated();
  if (!token) return;

  const userProfile = getUserProfile();
  updateUserState(userProfile);
};
